import { FC } from 'react';
import { useMeasure } from 'react-use';

// Quarks
import Flex from 'quarks/Flex';

import MinimalCard from 'components/CardDeck/MinimalCardDeck/MinimalCard';
import SliderArrows from 'components/CardDeck/SliderArrows';

import useSwipeable from 'utils/useSwipeable';

import type { ContentfulComponentCardDeck } from 'graphqlTypes';

interface MinimalCardDeckSliderProps extends ContentfulComponentCardDeck {
  backgroundIsDark?: boolean;
}

const MinimalCardDeckSlider: FC<MinimalCardDeckSliderProps> = ({ card, ...props }) => {
  const length = card?.length || 0;
  const [ref, { width: cardWidth }] = useMeasure();
  const [activeIndex, setActiveIndex, cardContainerRef] = useSwipeable(length);

  return (
    <Flex
      flexDirection="column"
      gap="48px"
      {...props}
      css={`
        width: 100%;
        clip-path: inset(-100vw -100vw -100vw 0);
      `}
    >
      <Flex
        flexDirection="column"
        gap="16px"
        css={`
          position: relative;
        `}
      >
        {card && (
          <Flex
            gap="30px"
            justifyContent="flex-start"
            transform={`translateX(-${activeIndex * cardWidth + activeIndex * 30}px)`}
            transition="transform 400ms cubic-bezier(0.215, 0.610, 0.355, 1.000)"
            minWidth={`calc(100% * ${length} + (30px * ${length - 1}))`}
            marginBottom={length > 3 ? 0 : 48}
            ref={cardContainerRef}
          >
            {card?.slice(0, length || 6)?.map(eguide => (
              <Flex key={eguide?.id} ref={ref} width="100%" maxWidth="100%" sm={{ maxWidth: '370px' }}>
                <MinimalCard card={eguide} isSlider />
              </Flex>
            ))}
          </Flex>
        )}
        {length && length > 3 && (
          <SliderArrows activeIndex={activeIndex} setActiveIndex={setActiveIndex} length={length} />
        )}
      </Flex>
    </Flex>
  );
};

export default MinimalCardDeckSlider;
